import Alert, { alertClasses } from '@mui/material/Alert'
import { styled } from '@mui/material/styles'

export const SalesAttributionAlert = styled(Alert)({
  [`& .${alertClasses.icon}`]: {
    paddingTop: '0px',
  },
  fontWeight: '400',
  fontSize: '14px',
  width: '100%',
})
